module.exports = __webpack_public_path__ + "static/media/lock_icon.c70bf284.svg";